export default {
      id: "icon-search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.10719bc6.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }